
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/loan-emi-calculator-complete-guide",
      function () {
        return require("private-next-pages/blogs/loan-emi-calculator-complete-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/loan-emi-calculator-complete-guide"])
      });
    }
  